// Future Station Brand Constants

export const BRAND = {
  name: 'Future Station',
  tagline: 'Fluig Experts',
  description: 'Especialistas em soluções Fluig com inovação e excelência técnica',
  email: 'contato@futurestation.com.br',
  phone: '+55 81 8165-8439',
  phoneNumber: '558181658439',
  website: 'https://futurestation.com.br',
  presence: 'Olinda - Pernambuco',
  experience: '300.000+ horas',
} as const;

export const COLORS = {
  primary: {
    purple: '#8B5CF6',
    cyan: '#0EA5E9', 
    magenta: '#F43F5E',
    dark: '#020617',
  },
  gradients: {
    hero: 'linear-gradient(135deg, #8B5CF6, #0EA5E9)',
    accent: 'linear-gradient(135deg, #F43F5E, #8B5CF6)',
    dark: 'linear-gradient(135deg, #020617, #0F172A)',
  },
} as const;

export const ANIMATIONS = {
  duration: {
    fast: 200,
    normal: 300,
    slow: 500,
  },
  easing: {
    smooth: 'cubic-bezier(0.4, 0, 0.2, 1)',
    bounce: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)',
  },
} as const;

export const BREAKPOINTS = {
  mobile: '640px',
  tablet: '768px',
  desktop: '1024px',
  wide: '1280px',
  ultrawide: '1536px',
} as const;

export const SERVICES = [
  'Fluig Flows/FluigApps',
  'Desenvolvimento Customizado',
  'Outsourcing Prime Club',
  'Integração TOTVS (Protheus/RM)',
  'Consultoria Especializada',
] as const;

export const WHATSAPP_MESSAGES = {
  hero: "Olá! Gostaria de falar com um especialista sobre soluções Fluig.",
  services: "Olá! Tenho interesse nos serviços Fluig da Future Station.",
  contact: "Olá! Vim do site e gostaria de solicitar uma demonstração.",
  flows: "Olá! Gostaria de conhecer os 16 Fluig Flows disponíveis.",
  outsourcing: "Olá! Tenho interesse no Outsourcing Prime Club.",
  default: "Olá! Vim do site e gostaria de conhecer as soluções Fluig da Future Station."
} as const;

export const FORM_OPTIONS = {
  companySize: [
    { value: "1-10", label: "1-10 funcionários" },
    { value: "11-50", label: "11-50 funcionários" },
    { value: "51-200", label: "51-200 funcionários" },
    { value: "201-1000", label: "201-1000 funcionários" },
    { value: "1000+", label: "Mais de 1000 funcionários" }
  ],
  interests: [
    { value: "fluig-flows", label: "Fluig Flows" },
    { value: "desenvolvimento", label: "Desenvolvimento" },
    { value: "outsourcing", label: "Outsourcing" },
    { value: "integracao-totvs", label: "Integração TOTVS" },
    { value: "consultoria", label: "Consultoria" }
  ]
} as const;

export const NAVIGATION = {
  main: [
    { name: 'Início', href: '#home' },
    { name: 'Sobre', href: '#about' },
    { name: 'Serviços', href: '#services' },
    { name: 'Portfolio', href: '#portfolio' },
    { name: 'Contato', href: '#contact' },
  ],
  footer: [
    { name: 'Política de Privacidade', href: '/privacy' },
    { name: 'Termos de Uso', href: '/terms' },
    { name: 'Blog', href: '/blog' },
    { name: 'Carreiras', href: '/careers' },
  ],
} as const;